module.exports = __webpack_public_path__ + "media/slots_gold_country_old_mine_ambience.265ccf41.mp3";